// extracted by mini-css-extract-plugin
export default {"contenedor":"InputFormulario_contenedor__yGZ8R","input":"InputFormulario_input__6t0M6","msjError":"InputFormulario_msjError__PCLG-","error":"InputFormulario_error__chNkN"};